import { UseQueryOptions } from 'react-query';
import { ServiceError } from '../../../../../hooks/error';
import { useCustomQuery } from '../../../../../hooks/query';
import { ResitDownloadSummary } from '../../../../../models/@candidate/candidateResitRegistrationSchema';
import {
  getCandidateDownloadSummary,
  getCandidateResitRegisterPayment,
  getResitReceiptSummary,
} from '../api-services/api';
import { GetResitPaymentTransaction, GetResitReceiptSummary } from '../models';
import {
  GET_CANDIDATE_RESIT_TRANSACTION,
  GET_RESIT_CANDIDATE_DOWNLOAD_SUMMARY,
  GET_RESIT_RECEIPT_SUMMARY,
} from './keys';

/** to get the candidate resit payment transaction
 * */
export const useGetCandidateResitTransaction = (
  internalTransactionRef = '',
  queryOptions?:
    | UseQueryOptions<GetResitPaymentTransaction, ServiceError, GetResitPaymentTransaction>
    | undefined
) =>
  useCustomQuery(
    [GET_CANDIDATE_RESIT_TRANSACTION, internalTransactionRef],
    () => getCandidateResitRegisterPayment(internalTransactionRef).then((res) => res.data),
    queryOptions,
    true,
    true
  );

/** to get resit receipt summary
 * */
export const useResitReceiptSummary = (
  internalTransactionRef = '',
  queryOptions?:
    | UseQueryOptions<GetResitReceiptSummary, ServiceError, GetResitReceiptSummary>
    | undefined
) =>
  useCustomQuery(
    [GET_RESIT_RECEIPT_SUMMARY, internalTransactionRef],
    () => getResitReceiptSummary(internalTransactionRef).then((response) => response.data),
    queryOptions,
    true,
    true
  );

/**
 * To retrieve download pre-signed url for download resit summary for candidate
 * @param internalTransactionRef internal transaction ref to search
 * @returns
 */
export const useCandidateDownloadSummary = (
  onSuccess: (download: ResitDownloadSummary) => void,
  internalTransactionRef = ''
) =>
  useCustomQuery<ResitDownloadSummary>(
    [GET_RESIT_CANDIDATE_DOWNLOAD_SUMMARY, internalTransactionRef],
    () => getCandidateDownloadSummary(internalTransactionRef).then((res) => res.data),
    {
      enabled: false,
      onSuccess,
    }
  );
